import { Show } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';

import {
  COLOR_BY_SESSION_RECAP_STATUS,
  SESSION_RECAP_STATUS_LABEL,
} from 'features/sessions/config';
import {
  SessionRecapStatusType,
  SessionsTableRowDataType,
} from 'features/sessions/config/types';

import { Badge, BADGE_COLORS } from 'shared/components/Badge';
import { Typography } from 'shared/components/Typography';

type SessionsTableRecapCellProps = {
  value: SessionRecapStatusType;
  row: SessionsTableRowDataType;
};

export const SessionsTableRecapCell = ({
  value: recapStatus,
}: SessionsTableRecapCellProps) => {
  return (
    <Show when={recapStatus}>
      <Flex flexDirection="column" alignItems="flex-start">
        <Badge
          colorPalette={
            COLOR_BY_SESSION_RECAP_STATUS[recapStatus] as BADGE_COLORS
          }
        >
          <Typography
            type="small"
            color="whiteTotal"
            textTransform="uppercase"
            dataTestid="session-recap-status-cell"
          >
            {SESSION_RECAP_STATUS_LABEL[recapStatus]}
          </Typography>
        </Badge>
      </Flex>
    </Show>
  );
};
